import { equals } from '@/utils';

export default class {
  constructor() {
    this.reset();
  }

  reset() {
    this.cursor = null;
    this.selected = null;
  }

  updateCursor(cursor) {
    if(!equals(cursor, this.cursor)) {
      this.cursor = cursor;
      return true;
    } else {
      return false;
    }
  }

  updateSelected(selected) {
    if(!equals(selected, this.selected)) {
      this.selected = selected;
      return true;
    } else {
      return false;
    }
  }
}
